import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.regexp.replace.js";
import api from "../../utils/api";

/**
 * Reverse guard for the new_portal A/B experiment.
 *
 * The marketing site buckets the DEVICE for its Login/Register redirect, so a
 * customer assigned to the NEW portal can still land on this legacy one — from a
 * second device, a bookmark or a stale link — and nothing sends them back: the
 * new portal only redirects control-arm customers out to here. Without this they
 * spend the whole session in the wrong arm.
 *
 * Resolution happens in mb-portal-api (`GET /api/portal-version`) rather than
 * from the browser, for three reasons:
 *
 *  - the experiment identity is the LMS **customer id**, which lives on the
 *    portal user record server-side. The browser only has the portal user id,
 *    and the two are unrelated columns — asking the LMS for `customer_{userId}`
 *    resolves a different customer, and because the LMS lazily persists an
 *    assignment on resolve, it would also bucket that unrelated customer.
 *  - the API reads the `eoe` bucket too, so a stopped experiment resolves to the
 *    variant the admin pinned instead of looking unresolved.
 *  - it keeps customer identifiers and the LMS origin out of a public,
 *    unauthenticated browser request (and needs no CORS grant).
 *
 * Fails safe to this portal: only a CONFIRMED `new` variant redirects, so a
 * config gap, an outage or an unresolved variant keeps the customer here, and
 * there is no way to ping-pong with the new portal's own guard.
 */
var ENDPOINT = '/api/portal-version';
var lookup = null;
var isAnotherOrigin = function isAnotherOrigin(url) {
  if (!url) {
    return false;
  }
  try {
    return new URL(url, window.location.origin).origin !== window.location.origin;
  } catch (e) {
    return false;
  }
};
var fetchPortalVersion = function fetchPortalVersion() {
  if (!lookup) {
    lookup = api().get(ENDPOINT).then(function (response) {
      return response.data;
    }).catch(function () {
      return null;
    });
  }
  return lookup;
};

/**
 * Resolves true when the browser is being sent to the new portal, in which case
 * the caller must not continue the navigation it was about to make.
 */
export function redirectIfNewPortalCustomer() {
  return _redirectIfNewPortalCustomer.apply(this, arguments);
}
function _redirectIfNewPortalCustomer() {
  _redirectIfNewPortalCustomer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var portalVersion;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return fetchPortalVersion();
        case 1:
          portalVersion = _context.sent;
          if (!(!portalVersion || portalVersion.variant !== 'new')) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", false);
        case 2:
          if (isAnotherOrigin(portalVersion.portal_url)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", false);
        case 3:
          window.location.replace(portalVersion.portal_url);
          return _context.abrupt("return", true);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _redirectIfNewPortalCustomer.apply(this, arguments);
}
export function resetPortalVersionLookup() {
  lookup = null;
}
export default {
  redirectIfNewPortalCustomer: redirectIfNewPortalCustomer,
  resetPortalVersionLookup: resetPortalVersionLookup
};